import { Checkbox, CheckboxProps } from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";
import { ITagBroker } from "src/api/server/extended-search";
import { buildUrl } from "src/utils/responsive-image-util";

export type IBrokerOnChangeParams = { isChecked: boolean; brokerId: string };

interface IBrokerCheckbox extends Omit<CheckboxProps, "onChange"> {
    onChange: (props: IBrokerOnChangeParams) => void;
    isChecked: boolean;
    broker: ITagBroker;
}

export const BrokerCheckbox = ({ broker, isChecked, onChange, ...boxProps }: IBrokerCheckbox) => {
    return (
        <Checkbox
            {...boxProps}
            whiteSpace="nowrap"
            key={broker.brokerId}
            isChecked={isChecked}
            onChange={event => {
                onChange({ isChecked: event.target.checked, brokerId: broker.brokerId });
            }}
        >
            <Image h="16px" src={buildUrl(broker.logoUrl)} alt={broker.partnerName} />
        </Checkbox>
    );
};
